import React, { useState } from 'react'
import { Grid, GridItem, Tr, Td, Flex, Badge } from '@chakra-ui/react'
import { Table, Spinner, Alert } from '../UI'
import { FormatDate, FormatMoney } from '../../Utils'
import { useDiscounts } from '../../hooks/Discounts'

const monthOrder = {
  "Enero": 1,
  "Febrero": 2,
  "Marzo": 3,
  "Abril": 4,
  "Mayo": 5,
  "Junio": 6,
  "Julio": 7,
  "Agosto": 8,
  "Septiembre": 9,
  "Octubre": 10,
  "Noviembre": 11,
  "Diciembre": 12
}

const TableDiscountsPartners = ({ filtersDiscounts, limit, tableSize }) => {
  const [page, setPage] = useState(0)
  const {
    data: discountsList,
    isLoading,
    isFetching,
    isError
  } = useDiscounts(filtersDiscounts, page, limit)
  const headers = [
    '#',
    'Fecha de Creación',
    'Fecha de Descuento',
    'Monto Descontado',
    'Observaciones',
    'Comprobantes'
  ]

  const sortData = (data = []) => {
    return (discountsList?.currentPages || []).sort((a, b) => {
      const dateA = parseInt(a.year) * 100 + monthOrder[a.month];
      const dateB = parseInt(b.year) * 100 + monthOrder[b.month];
      return dateB - dateA
    })
  }

  return (
    <Grid templateColumns={'repeat(1, 1fr)'} w={'100%'}>
      <Flex w={'100%'} justify={'flex-end'} py={3}>
        <Spinner size={'lg'} show={isLoading || isFetching} />
      </Flex>
      {isError && (
        <Flex w={'100%'} justify={'flex-end'} py={3}>
          <Alert status={'error'} message={'Error al Cargar los Datos'} />
        </Flex>
      )}
      <GridItem
        overflowX={'auto'}
        display={{
          lg: 'table',
          md: 'break-word',
          sm: 'break-word'
        }}
        css={{
          '&::-webkit-scrollbar': {
            width: '4px'
          },
          '&::-webkit-scrollbar-track': {
            width: '6px'
          },
          '&::-webkit-scrollbar-thumb': {
            background: '#2E7423',
            borderRadius: '20px'
          }
        }}
      >
        <Table
          headers={headers}
          totalRecords={discountsList?.totalRecords}
          setPage={setPage}
          page={page}
          size={tableSize}
          limit={limit}
        >
          {sortData(discountsList?.currentPages || [])?.map((item, index) => (
            <Tr key={item._id}>
              <Td fontWeight={700} color={'grey.500'} textAlign={'center'}>
                {index + 1 + page * limit}
              </Td>
              <Td color={'grey.500'}>{FormatDate(`${item?.createdAt}`)}</Td>
              <Td color={'grey.500'}>
                {item?.month} {item?.year}
              </Td>
              <Td color={'grey.500'}>$ {FormatMoney(item?.amount)}</Td>
              <Td color={'grey.500'}>
                {item?.observations || 'Sin observaciones'}
              </Td>
              <Td color={'grey.500'}>
                {item?.support?.map((file) => (
                  <Badge
                    key={file.url}
                    colorScheme={'green'}
                    mr={2}
                    fontSize="0.8em"
                    cursor={'pointer'}
                    onClick={() => window.open(file.url, '_blank')}
                  >
                    {file.name}
                  </Badge>
                ))}
              </Td>
            </Tr>
          ))}
        </Table>
      </GridItem>
    </Grid>
  )
}

export default TableDiscountsPartners
